import { Link } from "react-router-dom";
import { Play } from "../../../assets/icons";
import { CatalogFreeTag, ContentAccessBadge } from "../badge/FreeBadge";
import CatalogCoverImage from "./CatalogCoverImage";
import CatalogInstructorRow from "./CatalogInstructorRow";

export default function CatalogTileCard({
	to,
	title,
	imageUrl,
	imageSlot = null,
	actionLabel,
	subtitle,
	metaLine,
	metaSlot,
	instructorItem,
	instructorAvatarUrl,
	subtitleMuted = false,
	showDoctorRow = true,
	showFreeBadge = false,
	accessBadgeText,
	accessUnlocked = false,
	topRightBadge,
	imageTagText,
	imageOverlay = "none",
	footerWithPlayIcon = false,
	roundedClass = "rounded-[14px]",
}) {
	return (
		<Link
			to={to}
			className={[
				"group block h-full min-w-0 max-w-full no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta/40 focus-visible:ring-offset-2",
				roundedClass,
			].join(" ")}
		>
			<div
				className={[
					"relative flex h-full min-w-0 max-w-full flex-col overflow-hidden border border-darkBlue/10 bg-white p-[10px]",
					roundedClass,
					"shadow-[0_4px_16px_rgba(39,106,166,0.06)]",
					"transition duration-200 group-hover:border-darkBlue/20 group-hover:shadow-[0_8px_24px_rgba(39,106,166,0.12)]",
				].join(" ")}
			>
				<div
					className="pointer-events-none absolute inset-y-3 left-0 z-0 w-[3px] rounded-full bg-gradient-to-b from-cta to-darkBlue opacity-80"
					aria-hidden
				/>

				<div className="relative z-[1] w-full min-w-0 max-w-full">
					{showFreeBadge && (
						<CatalogFreeTag className="absolute right-2 top-2 z-10" />
					)}
					{accessBadgeText && !showFreeBadge && (
						<ContentAccessBadge
							label={accessBadgeText}
							unlocked={accessUnlocked}
							className="absolute right-2 top-2 z-10 max-w-[calc(100%-12px)]"
						/>
					)}
					{(imageTagText || topRightBadge) &&
						!showFreeBadge &&
						!accessBadgeText && (
							<span className="absolute right-2 top-2 z-10 max-w-[calc(100%-12px)] rounded-[10px] border border-[#1e4570] bg-darkBlue/90 px-2 py-1 font-Vazir-700 text-[11px] leading-snug text-white shadow-md line-clamp-2">
								{imageTagText || topRightBadge}
							</span>
						)}
					{imageSlot ?? (
						<CatalogCoverImage
							src={imageUrl}
							alt={title || ""}
							emptyVariant={imageOverlay === "play" ? "play" : "cover"}
							imgClassName="transition duration-300 group-hover:scale-[1.03]"
						/>
					)}
					{imageOverlay === "play" && (
						<div
							className={[
								"pointer-events-none absolute inset-0 flex items-center justify-center rounded-[10px]",
								"bg-darkBlue/0 transition duration-200 group-hover:bg-darkBlue/15",
							].join(" ")}
							aria-hidden
						>
							<span
								className={[
									"flex h-11 w-11 items-center justify-center rounded-full bg-white/95 shadow-md",
									"scale-90 opacity-0 transition duration-200 group-hover:scale-100 group-hover:opacity-100",
								].join(" ")}
							>
								<Play width={14} height={15} />
							</span>
						</div>
					)}
				</div>

				<h3 className="mt-3 min-h-[2.75rem] text-right font-Vazir-700 text-[16px] leading-6 text-midGray line-clamp-2 transition-colors group-hover:text-darkBlue">
					{title}
				</h3>

				{metaSlot ? (
					<div className="mt-2 flex min-h-[34px] w-full items-center justify-start text-right">
						{metaSlot}
					</div>
				) : metaLine ? (
					<p
						className="mt-1.5 font-Vazir-400 text-[13px] leading-snug text-darkBlue/65"
						dir="ltr"
					>
						{metaLine}
					</p>
				) : null}

				{showDoctorRow && (
					<CatalogInstructorRow
						className="mt-2"
						item={instructorItem}
						subtitle={subtitle}
						instructorAvatarUrl={instructorAvatarUrl}
						subtitleMuted={subtitleMuted}
					/>
				)}

				<div className="mt-auto flex min-h-[44px] items-center pt-3">
					<span
						className={[
							"flex w-full items-center justify-center gap-2 rounded-[10px] border border-darkBlue/10",
							"bg-gradient-to-l from-lightCta to-white py-2.5",
							"font-Vazir-600 text-[13px] text-darkBlue",
							"transition duration-200 group-hover:border-cta/40 group-hover:text-cta group-hover:shadow-[0_2px_10px_rgba(255,106,75,0.12)]",
						].join(" ")}
					>
						{footerWithPlayIcon && <Play width={12} height={13} />}
						{actionLabel}
					</span>
				</div>
			</div>
		</Link>
	);
}
